export default "__VITE_ASSET__gO2AnKJ7__"